/* ==========================================================================
   BYMOON.CARE — Ficha de producto (fase 2, 17-sep-2026)
   Lo consume snippets/product-benefits.liquid

   Hace tres cosas, sin tocar main-product.liquid:
   1. Sube la línea de cuotas justo debajo del precio.
   2. Convierte la descripción en acordeón y agrega "Envíos y pagos".
   3. Arma la barra fija de compra en celular, que aparece cuando el botón
      real deja de verse y al tocarla hace clic en ese mismo botón.

   La hora de corte y los umbrales de envío se leen de data-* en el HTML del
   snippet, para no repetir números en dos archivos.
   ========================================================================== */

(function () {
  'use strict';

  function $(sel, raiz) { return (raiz || document).querySelector(sel); }

  function infoFicha() {
    return $('.bym-ficha-datos');
  }

  // ---------- 1. Cuotas debajo del precio ----------
  function moverCuotas() {
    var cuotas = $('.bym-cuotas');
    if (!cuotas || cuotas.dataset.colocada === 'true') return;
    var precio = $('.product__info-container [id^="price-"]');
    if (!precio) return;
    precio.insertAdjacentElement('afterend', cuotas);
    cuotas.dataset.colocada = 'true';
  }

  // ---------- 1b. Valor de la cuota de Addi ----------
  // El precio visible ya lo actualiza el tema al cambiar de tono: de ahí se lee.
  function pesos(n) {
    return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function numeroPrecio() {
    var t = textoPrecio();
    if (!t) return 0;
    var m = t.replace(/[^\d.,]/g, '').replace(/[.,](\d{2})$/, '').replace(/[^\d]/g, '');
    var n = parseInt(m, 10);
    return isNaN(n) ? 0 : n;
  }

  function cuotaAddi() {
    var caja = $('.bym-cuotas');
    if (!caja) return;
    var destino = $('.bym-cuotas__addi .bym-cuotas__texto', caja);
    if (!destino) return;

    var cuotas = parseInt(caja.getAttribute('data-cuotas'), 10);
    if (isNaN(cuotas) || cuotas < 2) cuotas = 3;
    var minimo = parseInt(caja.getAttribute('data-minimo'), 10);
    if (isNaN(minimo)) minimo = 0;

    var precio = numeroPrecio();
    var marca = ' con <strong class="bym-marca-addi">Addi</strong>';
    var html;
    if (precio >= minimo && precio > 0) {
      html = cuotas + ' cuotas sin interés de <strong class="bym-cuotas__monto">' +
        pesos(Math.ceil(precio / cuotas)) + '</strong>' + marca;
    } else {
      // Por debajo del mínimo de Addi: en vez de una frase muerta, se invita a sumar.
      html = 'Desde <strong class="bym-cuotas__monto">' + pesos(minimo) + '</strong> pagas a ' +
        cuotas + ' cuotas sin interés' + marca;
    }
    if (destino.innerHTML !== html) destino.innerHTML = html;
  }

  // ---------- 2. Acordeones ----------
  function acordeones() {
    var cont = $('.product__info-container');
    if (!cont || cont.dataset.bymAcc === 'true') return;
    var datos = infoFicha();
    if (!datos) return;

    var desc = $('.product__info-container > .product__description');
    if (desc) {
      var det = document.createElement('details');
      det.className = 'bym-acc';
      det.open = false;
      var sum = document.createElement('summary');
      sum.textContent = 'Descripción';
      det.appendChild(sum);
      desc.parentNode.insertBefore(det, desc);
      desc.classList.add('bym-acc__body');
      det.appendChild(desc);
    }

    var envios = document.createElement('details');
    envios.className = 'bym-acc';
    var sum2 = document.createElement('summary');
    sum2.textContent = 'Envíos y pagos';
    envios.appendChild(sum2);
    var cuerpo = document.createElement('div');
    cuerpo.className = 'bym-acc__body';
    cuerpo.innerHTML = datos.dataset.envios || '';
    envios.appendChild(cuerpo);
    var refDesc = $('.product__info-container > .bym-acc');
    if (refDesc) {
      refDesc.parentNode.insertBefore(envios, refDesc.nextSibling);
    } else {
      cont.appendChild(envios);
    }

    cont.dataset.bymAcc = 'true';
  }

  // ---------- 3. Barra fija de compra ----------
  function textoPrecio() {
    var p = $('.product__info-container [id^="price-"] .price-item--sale, .product__info-container [id^="price-"] .price-item--regular');
    return p ? p.textContent.replace(/,00(?!\d)/g, '').trim() : '';
  }

  function barraFija() {
    var boton = $('.product-form__submit');
    if (!boton) return;
    var barra = $('.bym-sticky');

    if (!barra) {
      var datos = infoFicha();
      barra = document.createElement('div');
      barra.className = 'bym-sticky';
      barra.innerHTML =
        '<div class="bym-sticky__info">' +
        '<p class="bym-sticky__name"></p>' +
        '<p class="bym-sticky__price"></p>' +
        '</div>' +
        '<button type="button" class="bym-sticky__btn"></button>';
      document.body.appendChild(barra);
      $('.bym-sticky__name', barra).textContent = (datos && datos.dataset.titulo) || '';
      $('.bym-sticky__btn', barra).addEventListener('click', function () {
        var real = $('.product-form__submit');
        if (real && !real.disabled) real.click();
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entradas) {
          for (var i = 0; i < entradas.length; i++) {
            barra.classList.toggle('visible', !entradas[i].isIntersecting);
          }
        }, { rootMargin: '-10px 0px 0px 0px' }).observe(boton);
      } else {
        barra.classList.add('visible');
      }
    }

    var precio = textoPrecio();
    var pEl = $('.bym-sticky__price', barra);
    if (pEl && pEl.textContent !== precio) pEl.textContent = precio;

    var btn = $('.bym-sticky__btn', barra);
    var etiqueta = boton.disabled ? 'Agotado' : 'Agregar';
    if (btn.textContent !== etiqueta) btn.textContent = etiqueta;
    if (btn.disabled !== boton.disabled) btn.disabled = boton.disabled;
  }

  function pintar() {
    moverCuotas();
    cuotaAddi();
    acordeones();
    barraFija();
  }

  function arrancar() {
    if (!$('.product__info-container')) return;
    pintar();
    // El tema reemplaza el precio y el botón al cambiar de tono
    if ('MutationObserver' in window) {
      var pendiente = null;
      new MutationObserver(function () {
        if (pendiente) return;
        pendiente = setTimeout(function () { pendiente = null; pintar(); }, 80);
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('click', function () { setTimeout(pintar, 300); }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
